import firebaseApp from "../firebase/credenciales";
import { getFunctions, httpsCallable } from "firebase/functions";
import { getAuth } from "firebase/auth";

const auth = getAuth(firebaseApp);
const functions = getFunctions(firebaseApp, "us-central1");

/**
 * Alta individual de un usuario por Cloud Function (`crearUsuario`).
 *
 * POR QUÉ NO SE ESCRIBE DESDE EL CLIENTE
 * --------------------------------------
 * El modal de "Nuevo Usuario" escribía la ficha con el SDK de cliente (`setDoc`
 * en `src/functions/añadirProducto.js`). Las reglas de Firestore desplegadas en
 * producción permiten `create` en `users` SOLO a los administradores de
 * plataforma:
 *
 *   match /users/{userId} {
 *     allow create, delete: if esAdmin();
 *   }
 *
 * Pero el panel habilita el botón a quien tenga el permiso granular
 * `usuarios → USUARIOS_EDITAR` (roles `asistente`, `rh`, …). Para esos roles el
 * `setDoc` se rechazaba con `permission-denied` → «Missing or insufficient
 * permissions.», y la cuenta de Firebase Auth ya había quedado creada (la
 * contraseña es el DNI).
 *
 * La callable escribe con el Admin SDK —que ignora las reglas— y replica en el
 * servidor las mismas restricciones que aplican las reglas (permiso granular +
 * empresa + lista negra), de modo que el backend no queda más abierto que
 * antes.
 *
 * @param {Object} infoUsuario  Ficha del usuario (dni, email, name, apellidos…).
 * @returns {Promise<{success: boolean, message?: string, code?: string}>}
 */
const crearUsuario = async (infoUsuario) => {
  try {
    const currentUser = auth.currentUser;
    if (!currentUser) {
      return {
        success: false,
        message: "Sesión no válida. Vuelve a iniciar sesión e intenta nuevamente.",
      };
    }

    // Fuerza la renovación del token para que la callable reciba la identidad.
    const idToken = await currentUser.getIdToken(true);

    const crearUsuarioCallable = httpsCallable(functions, "crearUsuario");
    const response = await crearUsuarioCallable({ ...infoUsuario, idToken });
    const data = response?.data || {};

    return {
      success: true,
      message: data.message || "¡Usuario creado exitosamente!",
      action: data.action,
      uid: data.uid,
    };
  } catch (error) {
    console.error("Error al crear usuario:", error);
    return {
      success: false,
      code: error?.code || "",
      message:
        error?.message ||
        "No se pudo crear el usuario. Inténtalo de nuevo o contacta al administrador.",
    };
  }
};

export default crearUsuario;
